const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function Svg17IconoCerrarSesion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.72 18.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8779f5;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cerrar_sesi\xF3n",
    "data-name": "Cerrar sesi\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.36,18.65A8.42,8.42,0,0,1,0,10.19,8.5,8.5,0,0,1,2.87,3.83l.62.7A7.53,7.53,0,0,0,8.36,17.72,7.53,7.53,0,0,0,13.23,4.53l.62-.7a8.5,8.5,0,0,1,2.87,6.36A8.42,8.42,0,0,1,8.36,18.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.89,
    width: 0.93,
    height: 9.52
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17IconoCerrarSesion);
export default __webpack_public_path__ + "static/media/17_Icono_Cerrar_sesion.6b3a8651aaf276066953471ce7f98eeb.svg";
export { ForwardRef as ReactComponent };